import { W as WuiTagList$1, d as defineCustomElement$1 } from './p-BQe00Bfh.js';

const WuiTagList = WuiTagList$1;
const defineCustomElement = defineCustomElement$1;

export { WuiTagList, defineCustomElement };
